import {requirePermission} from '@/modules/auth/permissions'
import {SectionForm} from '@/modules/sections/components/section-form/section-form'
import {NewResourceFormContainer} from '@cypro/ui/components/ui/new-resource-form-container'
import {NewResourceFormHeader} from '@cypro/ui/components/ui/new-resource-form-header'
import {createFileRoute} from '@tanstack/react-router'
import {useTranslate} from '@tolgee/react'
import * as z from 'zod'

const EditSectionPageSchema = z.object({
  sectionId: z.string().optional(),
})

export const Route = createFileRoute('/configuration/sections/new')({
  beforeLoad: requirePermission('organisation.manage'),
  component: NewSectionPage,
  validateSearch: EditSectionPageSchema,
})

function NewSectionPage() {
  const {t} = useTranslate('sections')

  const {sectionId} = Route.useSearch()

  return (
    <NewResourceFormContainer>
      <NewResourceFormHeader
        title={sectionId ? t('edit_section_title') : t('new_section_title')}
        description={t('new_section_description')}
      />

      <SectionForm sectionId={sectionId} />
    </NewResourceFormContainer>
  )
}
